// extracted by mini-css-extract-plugin
export default {"wrapper":"IconBadge_wrapper__fsbTH"};